
import {
  defineAsyncComponent,
    onMounted,
    ref,
 } from 'vue'; 

import useInventarios from '../composables/useInventarios';

import numeral from 'numeral';

export default {
    components: {
        KardexEditarEntradaSalidaComponent: defineAsyncComponent(
            () => import('@/modules/ventas/components/KardexEditarEntradaSalidaComponent.vue')
        ),
    },
    setup() {
        const {
            obtenerKardexProductos,
        } = useInventarios();

        const headers = [
            { text: 'Producto', value: 'nombre_producto', sortable: true },
            { text: 'Marca', value: 'nombre_marca', sortable: true },
            { text: 'Saldo Inicial', value: 'saldo_inicial', sortable: true },
            { text: 'Entradas', value: 'entradas', sortable: true },
            { text: 'Salidas', value: 'salidas', sortable: true },
            { text: 'Saldo', value: 'saldo', sortable: true },
            // { text: '', value: 'acciones', width: 15 },
        ];

        let kardexs: any = [];
        const kardexsFiltrados = ref<any[]>([]);

        const textoFiltro = ref<string>('');

        const kardexEditarEntradaSalidaComponentRef = ref();

        onMounted(async() => {
            await buscarKardex();
        });

        const buscarKardex = async () => {
            const resp = await obtenerKardexProductos();
            if (resp.ok) {
                kardexs = resp.data;
                kardexsFiltrados.value = JSON.parse(JSON.stringify(kardexs));
            }
        }

        const nuevaEntrada = async () => {
            kardexEditarEntradaSalidaComponentRef.value.abrirComponent('entrada');
        }

        const nuevaSalida = async () => {
            kardexEditarEntradaSalidaComponentRef.value.abrirComponent('salida');
        }

        const filtrarInformacion = async () => {
            kardexsFiltrados.value = JSON.parse(JSON.stringify(
                kardexs.filter(
                    (u: any) => u.nombre_producto.toLowerCase().includes(textoFiltro.value.toLowerCase())
                        || u.nombre_marca.toLowerCase().includes(textoFiltro.value.toLowerCase())
                )
            ));
        }

        const cerrarKardexEditarEntradaSalidaComponentEmit = async(seGrabo: boolean) => {
            console.log(seGrabo);
        }

        return {
            headers,
            textoFiltro,
            kardexsFiltrados,

            buscarKardex,
            filtrarInformacion,
            nuevaEntrada,
            nuevaSalida,

            numeral,

            kardexEditarEntradaSalidaComponentRef,
            cerrarKardexEditarEntradaSalidaComponentEmit,
};
    }
}
